import React, { Fragment } from 'react';

import {
  Tooltip,
  Avatar,
  Box,
  Card,
  Grid,
  colors,
  Icon,
  makeStyles,
  CardContent,
  Typography,
  Divider,
  Button,
  IconButton
} from '@material-ui/core';

import { RiEqualizerLine } from "react-icons/ri";
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import { RiFlowChart } from "react-icons/ri";

const useStyles = makeStyles((theme) => ({
  root: {
  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200],
    width: 50,
    height: 50
  }
}));

const Results = ({ list, openEdition, openDeletion }) => {

  const classes = useStyles();

  return (
    <Fragment>
      <Box mt={3}>
        <Grid
          container
          spacing={3}
        >
          {list.map((config, index) => (
            <Grid
              item
              lg={4}
              md={6}
              xs={12}
            >

              <Card className={classes.root}>

                <CardContent>
                  <Box
                    display="flex"
                    justifyContent="center"
                    mb={3}
                  >

                    <Avatar
                      className={classes.avatar}
                    >
                      {<Icon component={RiEqualizerLine} style={{ color: colors.indigo[400] }} ></Icon>}
                    </Avatar>
                  </Box>

                  <Typography
                    align="center"
                    color="textPrimary"
                    gutterBottom
                    variant="h4"
                  >
                    <b>{config.code}</b>
                  </Typography>

                  <Typography
                    align="center"
                    color="textPrimary"
                    variant="body1"
                  >
                    {config.title}
                  </Typography>

                  <Typography
                    align="center"
                    color="textSecondary"
                    variant="h5"
                  >
                    <b>Itens:</b> ({(config.items) ? config.items.length : 0})
                  </Typography>

                </CardContent>

                <Divider />

                <Box p={1}>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={1}
                  >

                    <Grid
                      item
                      className={classes.statsItem}
                    >
                      <Tooltip title="Editar Parâmetro">
                        <IconButton
                          color="secondary"
                          className={classes.btntreatment}
                          children={<EditRoundedIcon />}
                          size="medium"
                          onClick={() => { openEdition(config) }}></IconButton>
                      </Tooltip>
                      <Tooltip title="Excluir Parâmetro" component="span" >
                        <IconButton
                          color="secondary"
                          disabled
                          className={classes.btntreatment}
                          children={<DeleteRoundedIcon />}
                          size="medium"
                          onClick={() => { openDeletion(config) }}></IconButton>
                      </Tooltip>

                    </Grid>

                    <Grid
                      className={classes.statsItem}
                      item
                    >
                      <Tooltip title="Visualizar estatistica de utilização">
                        <Button
                          color="secondary"
                          startIcon={<Icon component={RiFlowChart} style={{ color: colors.blue[400] }} ></Icon>}
                          size="small"
                          variant="text">
                          Referências
                        </Button>

                      </Tooltip>
                    </Grid>
                  </Grid>
                </Box>
              </Card>

            </Grid>
          ))}
        </Grid>
      </Box>
    </Fragment >
  );
};

export default Results;
